import { HandySvg } from "handy-svg";
import styles from "./blockOne.module.scss";
import Image from "next/image";
import Link from "next/link";
import PromptInfo from "../promptInfo/promptInfo";

export default function BlockOne({ data, load, isAuth, serviceData, handlerClick, isSoon, dictionary, thisIsApp, queryParams }) {
	const mainImageData = data.Main_image.data.attributes;
	const tryImageData = data.Try_out_image.data;
	const accept = `.jpg, .jpeg, .heic, .heif, .png, image/png, image/jpeg`;

	const tryImgHandlerClick = (file) => {
		fetch(file)
			.then((res) => res.blob())
			.then(async (blob) => {
				let imgFile = await new File([blob], "img.png", { type: blob.type });
				handlerClick([imgFile]);
			});
	};

	return (
		<section className={styles.section}>
			<div className={styles.text}>
				<h1 className={styles.title}>{data.Title}</h1>
				<p className={styles.description}>{data.Description}</p>

				{isSoon && (
					<button className={styles.btn} onClick={handlerClick} disabled={isAuth}>
						{dictionary["Coming soon"] || "Coming soon"}
					</button>
				)}

				{thisIsApp && (
					<div className={styles.appBtnWrapper}>
						<a className={styles.appBtn} href="https://apps.apple.com/us/app/id1592658212" target="_blank" rel="noreferrer" title="go to bgrem app for app store">
							<Image width={135} height={40} src="/footer/app_store_link_ico/app_store.png" alt="app store" />
						</a>
						<a
							className={styles.appBtn}
							href="https://play.google.com/store/apps/details?id=com.deelvin.bgrem&pcampaignid=web_share"
							target="_blank"
							rel="noreferrer"
							title="go to bgrem app for google play"
						>
							<Image width={135} height={40} src="/footer/app_store_link_ico/google_play.png" alt="app store" />
						</a>
					</div>
				)}

				{load && !isSoon && !thisIsApp && (
					<Link className={styles.btn} href={`/${serviceData.url_name}${queryParams !== "" ? `?${queryParams}` : ""}`}>
						{dictionary["Try"]}
					</Link>
				)}

			</div>

			<div className={styles.image}>
				<Image src={mainImageData.url} alt={mainImageData.alternativeText} width={mainImageData.width} height={mainImageData.height} loading="lazy" unoptimized={true} />
				{mainImageData.caption?.includes("prompt: ") && (<PromptInfo prompt={mainImageData.caption.replace("prompt: ", "")} />)}
			</div>
		</section>
	);
}
